import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { href: '#about', label: 'About' },
    { href: '#screenshots', label: 'Screenshots' },
    { href: '#features', label: 'Features' },
    { href: '#download', label: 'Download' },
    { href: '/shop', label: 'Shop' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-black/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/2a01d123cf9c4a82efb854c7b744e5ea/35b654b595e98d7cf9380ddfa54a23ca.png"
            alt="Amagi Poker"
            className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl"
          />
          <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">
            Amagi Poker
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-5 lg:gap-7">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-light hover:text-amber-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://t.me/AmagiPoker"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full border border-[#229ED9]/40 flex items-center justify-center hover:border-[#229ED9] text-[#229ED9] transition-colors cursor-pointer"
            title="Telegram Support"
          >
            <i className="ri-telegram-fill text-lg"></i>
          </a>
          <a
            href="https://apps.apple.com/us/app/amagi-poker-texas-holdem/id6749308770"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:border-amber-400 transition-colors cursor-pointer"
            title="App Store"
          >
            <i className="ri-apple-fill text-lg"></i>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.GAMEINCAMAGI.POKERAGG2D"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:border-amber-400 transition-colors cursor-pointer"
            title="Google Play"
          >
            <i className="ri-google-play-fill text-lg"></i>
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        } bg-black/95 backdrop-blur-md`}
      >
        <div className="px-6 pb-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-base font-light py-2 border-b border-white/10 hover:text-amber-400 transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://t.me/AmagiPoker"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center justify-center gap-3 px-6 py-3 bg-[#229ED9]/20 border border-[#229ED9]/40 rounded-full font-medium cursor-pointer whitespace-nowrap text-[#229ED9] hover:bg-[#229ED9]/30 transition-colors"
          >
            <i className="ri-telegram-fill text-lg"></i>
            <span>Contact Support</span>
          </a>
          <a
            href="https://apps.apple.com/us/app/amagi-poker-texas-holdem/id6749308770"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full font-medium cursor-pointer whitespace-nowrap"
          >
            <i className="ri-apple-fill text-lg"></i>
            <span>Download on App Store</span>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.GAMEINCAMAGI.POKERAGG2D"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 px-6 py-3 bg-zinc-800 border border-amber-400/40 rounded-full font-medium cursor-pointer whitespace-nowrap hover:border-amber-400 transition-colors"
          >
            <i className="ri-google-play-fill text-lg text-amber-400"></i>
            <span>Get it on Google Play</span>
          </a>
        </div>
      </div>
    </nav>
  );
}